import { FC } from 'react';
import { useYodaField } from 'services/yodaForm';
import { YodaFieldValidation } from 'services/yodaForm/yodaForm.types';
import Switch from 'yoda-ui/Switch';

type SwitchYodaProps = {
  name: string;
  defaultValue?: boolean;
  disabled?: boolean;
  onChange?: Function;
  validation?: YodaFieldValidation;
};

const SwitchYoda: FC<SwitchYodaProps> = ({
  name,
  defaultValue,
  disabled = false,
  validation,
  onChange,
}) => {
  const { fieldValue, onSwitchField } = useYodaField({ name, defaultValue, onChange, validation });

  return (
    <Switch
      name={ name }
      onSwitch={ onSwitchField }
      disabled={ disabled }
      checked={ fieldValue === true }
    />
  );
};

export default SwitchYoda;
